module.exports = __webpack_public_path__ + "5c114213/img/file-icon.c085e21e.svg";